import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, NgZone } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { BehaviorSubject } from 'rxjs';
import { Config } from '../../config/config';
import { MenuService } from '../directives/vnpt-menu.service';
import { SignalRService } from './signalR.service';
var Base64 = require('js-base64').Base64;

declare var $: any;

@Injectable()
export class AuthService {
    isLoggedIn: boolean = false;
    user: any;
    showHeader: boolean = true;
    showFooter: boolean = true;
    redirectUrl: string;
    description: string;
    menuItems: any[] = [];
    systemConfig: any = {};

    dsRoutes: any[];
    DanhSachCB: any[] = [];
    TongCB: number = 0;
    TongSLG: number = 0;
    idConnection: string = "";
    isLoading: boolean = false;

    private connection: any;
    private proxy: any;
    public chatConnected = false;
    // ==== Luôn khởi tạo EventEmitter ngay ====
    public userListReceived: EventEmitter<any> = new EventEmitter<any>();
    public messageReceived: EventEmitter<any> = new EventEmitter<any>();
    private chatStartPromise: Promise<void> | null = null;

    private modalSource = new BehaviorSubject<any>(null);
    modal$ = this.modalSource.asObservable();

    constructor(private _http: HttpClient,
        private service: MenuService,
        private signalRService: SignalRService,
        private ngZone: NgZone) {
        var token = localStorage.getItem("scnntttoken");
        console.log(token);

        // this.loadSystemConfig();

        if (token !== null && token != undefined) {
            this.isLoggedIn = true;
            var jsonString = localStorage.getItem("userInfo");

            if (jsonString != null && jsonString != undefined) {

                var decodedJSONString = Base64.decode(jsonString);
                let oUserInfo = JSON.parse(decodedJSONString);
                console.log(oUserInfo);
                // this.dsRoutes = oUserInfo.routesInfo;
                // this.user = oUserInfo.userInfo;                
                // this.showHeader = true;
                // this.showFooter = true;
                if (oUserInfo.isAthenticated) {
                    //Tạm thời connect signalR ở đây
                    console.log(`start ConnectSignalR`);
                    this.signalRService.connectSignalR();
                    console.log(`end ConnectSignalR`);
                    this.dsRoutes = oUserInfo.routesInfo;
                    this.user = oUserInfo.userInfo;
                    this.showHeader = true;
                    this.showFooter = true;
                } else {
                    this.isLoggedIn = false;
                    this.showHeader = false;
                    this.showFooter = false;
                    this.dsRoutes = [];
                    this.user = {};
                }

                //this.ConnectSignalR();
            }
        }
        else {
            this.isLoggedIn = false;
            this.showHeader = false;
            this.showFooter = false;
            this.dsRoutes = [];
            this.user = {};
        }
        //console.log("Danh asch router");
        //console.log(this.dsRoutes);
    }

    loadSystemConfig(): Promise<any> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
        headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this._http
            .get(Config.apiUrl + 'HT_CauHinhCoQuan/SystemConfig', { headers: headers, observe: 'response' })
            .toPromise()
            .then((resp) => {
                let data = resp.body as { success: boolean, data: any, is_authenticated: boolean, first_change_pwd: boolean, expired_pwd: boolean };
                this.systemConfig = data.data;
                this.isLoading = false;
                this.isLoggedIn = data ? data.is_authenticated : false;

                if (data.is_authenticated) {
                    var id_token = localStorage.getItem("scnnttidtoken");
                    //not SSO login
                    if (!id_token && !data.first_change_pwd) {
                        this.sendToModal({ type: 'FIRST_CHANGE_PWD', data: {} })
                    } else if (!id_token && data.expired_pwd) {
                        this.sendToModal({ type: 'EXPIRED_PWD', data: {} })
                    }
                }

                return data;
            })
            .catch((error) => {
                this.isLoading = false;
                this.isLoggedIn = false;
                localStorage.clear();
                return true;
            });
    }

    loadMenu(username: string) {
        this.menuItems = [];
        this.service.GetMenu(username)
            .subscribe(
                (data) => {
                    this.menuItems = data;
                },
                er => {
                    console.log(er);
                });
    } //loadMenu

    Load_DanhSach_CanhBao() {
        this.service.DanhSach_CanhBao().subscribe(
            resp => {
                this.DanhSachCB = resp;
                if (resp.length > 0) {
                    this.TongCB = resp[0].TongCanhBao;
                    this.TongSLG = resp[0].TongSLG;
                }
                else {
                    this.TongCB = 0;
                    this.TongSLG = 0;
                }
            }
        )
    } //Load_DanhSach_CanhBao

    getUserRolesInfo(token, path) {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
        headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        var data = {
            routerPath: path
        }
        return this._http.post(Config.apiUrl + '/general/getuserrolesinfo', JSON.stringify(data), { headers: headers, observe: 'response' }).map(resp => {
            // this.loadSystemConfig();
            return resp.body;
        });
        // return this.dataService.post('general/getuserrolesinfo', data);
    } //getUserRolesInfo

    getWebPushKey() {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
        headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this._http.post(Config.apiUrl + 'general/getWebPushKey', JSON.stringify(''), { headers: headers, observe: 'response' }).map(resp => resp.body);
        // return this.dataService.post('general/getWebPushKey', '');
    } //getWebPushKey

    setSubscription(subscription: string) {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
        headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this._http.post(Config.apiUrl + 'general/setSubscription', JSON.stringify(subscription), { headers: headers, observe: 'response' }).map(resp => resp.body);
        // return this.dataService.post('general/setSubscription', subscription);
    } //setSubscription

    deleteSubscription() {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
        headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this._http.post(Config.apiUrl + 'general/deleteSubscription', JSON.stringify(''), { headers: headers, observe: 'response' }).map(resp => resp.body);
        // return this.dataService.post('general/deleteSubscription', '');
    } //deleteSubscription

    sendToModal(data: any) {
        console.log(`sendToModal`, data);
        this.modalSource.next(data);
    }

    encrypt(msg, pass) {
        // random salt for derivation
        var keySize = 256;
        var salt = CryptoJS.lib.WordArray.random(16);
        // well known algorithm to generate key
        var key = CryptoJS.PBKDF2(pass, salt, {
            keySize: keySize / 32,
            iterations: 100
        });
        // random IV
        var iv = CryptoJS.lib.WordArray.random(128 / 8);
        // specify everything explicitly
        var encrypted = CryptoJS.AES.encrypt(msg, key, {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        });
        // combine everything together in base64 string
        var result = CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));
        return result;
    }
    // Dong bo Trao doi thong tin
    // private connection: any;
    // private proxy: any;

    // public userListReceived: EventEmitter<any>;
    // public messageReceived: EventEmitter<any>;
    public ConnectSignalR(idYeuCau: string) {

        // create hub connection  
        this.connection = $.hubConnection(Config.url);
        this.connection.qs = { "access_token": localStorage.getItem("scnntttoken"), "idYeuCau": idYeuCau, "idNhanVien": this.user.Id };

        this.connection.error(function (error) {
            console.log('SignalR error: ' + error)
        });
        this.connection.disconnected(() => {
            setTimeout(() => {
                console.log('reconnect on disconnected');
                this.startConnection();
            }, 5000);
        });

        this.userListReceived = new EventEmitter<any>();
        this.messageReceived = new EventEmitter<any>();

        // create new proxy as name already given in top  
        this.proxy = this.connection.createHubProxy('ttshub');
        // register on server events  
        this.registerOnServerEvents();
        // call the connecion start method to start the connection to send and receive events.  
        this.startConnection();
    }

    public Disconnected(): void {
        if (this.getConnectionState() == '1' && this.proxy) {
            // server side hub method using proxy.invoke with method name pass as param  
            this.proxy.invoke('DoLogout');
            // this.connectionExists = false;
            this.setConnectionState('0');
            // this.connection.stop();
            // .done(() => {
            //   console.log('stop connection')
            // });
        }
    }

    public SendMessage(idYeuCau: number, noiDung: string) {
        if (this.getConnectionState() == '1') {
            // server side hub method using proxy.invoke with method name pass as param  
            this.proxy.invoke('SendMessage', idYeuCau, this.user.Id, noiDung);
        }
    }

    private startConnection(): void {
        this.connection.start().done((data: any) => {
            this.idConnection = data.id;
            //console.log('Now connected ' + data.transport.name + ', connection ID= ' + data.id);
            // this.connectionEstablished.emit(true);
            // this.connectionExists = true;
            this.setConnectionState('1');
            // this.proxy.invoke('SendCoQuanChatList', this.user.IdCoQuan);
        }).fail((error: any) => {
            console.log('Could not connect ' + error);
            // this.connectionEstablished.emit(false);
        });
    }

    private registerOnServerEvents() {
        // this.proxy.on('listNoiDung', (data) => {
        //     this.userListReceived.emit(data);
        // });
        this.proxy.on('Message', (data) => {
            this.messageReceived.emit(data);
        });
    }

    getConnectionState() {
        return localStorage.getItem("_conn_") || "0";
    }

    setConnectionState(value) {
        localStorage.setItem("_conn_", value);
    }

    public ConnectSignalRSkeleton(idYeuCau: string) {
        // DEV: stub fake incoming messages
        setInterval(() => {
            this.messageReceived.emit({
                IdYeuCau: idYeuCau,
                NoiDung: "🔧 Tin giả lập " + new Date().toLocaleTimeString(),
            });
        }, 5000);
        return;
        // … code thật khởi tạo $.hubConnection, proxy, v.v. …
    }

    public ConnectSignalR_Chat(idYeuCau: string): Promise<void> {
        if (!this.chatStartPromise) {
            // 1) Tạo connection & proxy
            this.connection = $.hubConnection(Config.url);
            this.connection.qs = {
                access_token: localStorage.getItem("scnntttoken"),
                idYeuCau,
                idNhanVien: this.user.Id.toString()
            };
            this.proxy = this.connection.createHubProxy("ttshub");

            // 2) Đăng ký event chỉ một lần
            this.proxy.on("Message", (data: any) => {
                // Bắt zone để view update tự động
                this.ngZone.run(() => {
                    this.messageReceived.emit(data);
                });
            });

            // 3) Tạo promise cho việc start()
            this.chatStartPromise = new Promise<void>((resolve, reject) => {
                this.connection.start()
                    .done(() => {
                        console.log("SignalR Chat connected");
                        this.chatConnected = true;
                        // Gửi lên server biết đã connect chat (nếu cần)
                        this.proxy.invoke("OnConnected_Chat");
                        resolve();
                    })
                    .fail((err: any) => {
                        console.error("SignalR Chat failed to start:", err);
                        reject(err);
                    });
            });
        }
        return this.chatStartPromise;
    }

    /**
     * Gửi tin nhắn riêng tư: sẽ chờ cho hub connected xong
     */
    public SendPrivateMessage_Chat(
        toNhanVien: string,
        fromNhanVien: number,
        noiDung: string,
        messageType: string = 'text',
        fileUrl: string | null = null
    ): Promise<any> {
        return this.ConnectSignalR_Chat("").then(() => {
            return this.proxy.invoke(
                "SendPrivateMessage_Chat",
                toNhanVien,
                fromNhanVien,
                noiDung,
                messageType,
                fileUrl
            );
        });
    }

    /** Đóng kết nối chat */
    public DisconnectSignalR_Chat(): void {
        if (this.proxy && this.chatConnected) {
            this.proxy.invoke("OnDisconnected_Chat", true);
            this.connection.stop();
            this.chatConnected = false;
            this.chatStartPromise = null;
        }
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/services/auth.service.ts